import {
  createApp, h,
} from 'vue';
import {
  createInertiaApp, router,
} from '@inertiajs/vue3'; // Import router here
import NProgress from 'nprogress';
import Notifications from 'notiwind';
import moment from 'moment-timezone';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import { createPinia } from 'pinia';
import setScrollBarWidth from 'set-scrollbar-width';
import { route } from 'ziggy-js';
import AppLayout from './Layouts/AppLayout.vue';

require('./bootstrap');

const pinia = createPinia();

// Configure NProgress without spinner
NProgress.configure({ showSpinner: false });

// Attach Inertia navigation events for NProgress
router.on('start', () => NProgress.start());
router.on('finish', (event) => {
  if (!event.detail.visit.completed) {
    NProgress.done();
  }
});

// Initialize the Inertia app using createInertiaApp
createInertiaApp({
  resolve: (name) => {
    const page = require(`./Pages/${name}`).default;
    page.layout = page.layout || AppLayout;

    return page;
  },
  setup({
    el, App, props, plugin,
  }) {
    const app = createApp({ render: () => h(App, props) });

    // Register global mixin methods for permission checks and roles
    app.mixin({
      methods: {
        route,
        can(permission) {
          return this.$page.props.permissions?.includes(permission);
        },

        role(role) {
          return this.$page.props.roles?.includes(role);
        },
      },
    });

    // Register plugins
    app.use(plugin)
      .use(Notifications)
      .use(moment)
      .use(setScrollBarWidth)
      .use(pinia)
      .use(VueGoogleMaps, {
        load: { key: process.env.MIX_GOOGLE_MAPS_API_KEY },
      });

    // Custom directive for detecting clicks outside elements
    app.directive('click-outside', {
      beforeMount(element, binding) {
        element.clickOutsideEvent = function handleOutsideClick(event) {
          if (!(element === event.target || element.contains(event.target))) {
            binding.value(event, element);
          }
        };
        document.body.addEventListener('click', element.clickOutsideEvent);
      },
      beforeUnmount(element) {
        document.body.removeEventListener('click', element.clickOutsideEvent);
      },
    });

    // Mount the app
    app.mount(el);
  },
}).catch((error) => {
  console.error('Error creating Inertia app:', error); // Error handling
});
